import { Grid, Typography } from "@mui/material";
import { intlFormatTime, toDate } from "helpers";
import { SalesTaskType } from "operations/schema/schema";
import { FC } from "react";
import { useIntl } from "react-intl";
import { JobStyles } from "styles/JobStyles";

const classes = JobStyles.createClasses();
const StyledBox = JobStyles.defineStyles(classes);

interface SalesTaskEventProps {
  salesTask: SalesTaskType;
  hideTimes?: boolean;
}

export const SalesTaskEvent: FC<SalesTaskEventProps> = (props: SalesTaskEventProps) => {
  const { salesTask, hideTimes } = props;
  const intl = useIntl();
  const plannedEndText = salesTask.dateTo;
  const plannedDays =
    salesTask.dateTo && salesTask.dateFrom
      ? Math.floor(
          (toDate(salesTask.dateTo).getTime() - toDate(salesTask.dateFrom).getTime()) /
            1000 /
            60 /
            60 /
            24
        )
      : 0;
  const dateText = salesTask.dateFrom;

  return (
    <StyledBox className="component-Job">
      <Grid container alignItems="center" wrap="nowrap">
        <Grid item minWidth="100%">
          <Grid container>
            <Grid item container justifyContent="space-between">
              <Grid item>
                <Typography variant="body2" component="h4" color="primary">
                  <span>{salesTask.taskSubject}</span>
                </Typography>
              </Grid>
              <Grid item>
                <Typography variant="body2" component="h4" color="primary">
                  <span>{salesTask.taskText}</span>
                </Typography>
              </Grid>
              <Grid item className={classes.jobTime}>
                <Grid item container direction="row" alignItems="center" spacing={1}>
                  {dateText && !hideTimes && (
                    <Grid item>
                      <Typography variant="body2" color="secondary">
                        {intlFormatTime(intl, dateText)}
                        {plannedDays < 1 && plannedEndText
                          ? ` - ${intlFormatTime(intl, plannedEndText)}`
                          : plannedDays === 1
                          ? ` (+1 ${intl.formatMessage({ id: "date.day" })})`
                          : plannedDays > 1 &&
                            ` (+${plannedDays} ${intl.formatMessage({ id: "date.days" })})`}
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </StyledBox>
  );
};
